import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MerchantCardComponent } from './merchant.component';
import { CardModule } from '../card.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LazyLoadImageModule,
    CardModule
  ],
  declarations: [
    MerchantCardComponent
  ],
  exports: [
    MerchantCardComponent
  ]
})
export class MerchantCardModule { }
